import App from "./src/App";
import React, {createContext, useContext, useEffect, useState} from "react";
import {post} from "../utils";
import {useAppContext} from "../Main";

const DashboardContext = createContext({});

export const useDashboardContext = () => useContext(DashboardContext);

export const Dashboard = () => {
    const {data, setData} = useAppContext();
    const [groups, setGroups] = useState(data.groups);
    const [groupsError, setGroupsError] = useState(null);

    useEffect(() => {
        post("https://ipresent.ru/api/vk-get-groups/").then(setGroups).catch(setGroupsError)
    }, []);

    const CONSTANTS = data.settings.dashboard;

    data.trialExpiring = data.customer.trialExpiring;
    data.paidExpiring = data.customer.paidExpiring;
    data.tariff_id = data.customer.tariff_id;
    data.isTrial = data.customer.isTrial;
    data.isPaid = data.customer.isPaid;
    data.email = data.vk.email;
    data.businessName = `${data.vk.first_name} ${data.vk.last_name}`;
    data.tariffs = data.settings.tariffs.map(tariff => ({
        ...tariff,
        nameText: CONSTANTS["TARIFF_DATA"].nameText.replace("{{tariff.name}}", tariff.name),
        priceText: CONSTANTS["TARIFF_DATA"].priceText.replace("{{tariff.priceMonthly}}", tariff["priceMonthly"]?.toLocaleString("ru")),
        priceAnnual: Math.round(tariff["priceMonthly"] * ((100 - data.settings.annualDiscountPercent) / 100)) * 12,
        priceAnnualText: CONSTANTS["TARIFF_DATA"].priceAnnualText.replace("{{tariff.priceAnnual}}", Math.round(tariff["priceMonthly"] * ((100 - data.settings.annualDiscountPercent) / 100)).toLocaleString("ru"))
    }));
    data.tariff = data.tariffs.find(tariff => tariff.id === data.tariff_id);

    data.onSendInvoice = async (price) => {
        const blob = await post("https://ipresent.ru/api/vk-send-invoice/", {price}, "blob");
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "invoice.pdf";
        link.click();
        URL.revokeObjectURL(url);
    }
    data.onSelectTariff = async (tariff_id) => {
        const {paidExpiring, isPaid} = await post("https://ipresent.ru/api/vk-select-tariff/", {tariff_id});
        data.paidExpiring = paidExpiring;
        data.isPaid = isPaid;
        data.customer.tariff_id = tariff_id;
        setData({...data});
    };
    data.editGroupManager = async (role, group_id) => {
        await post("https://ipresent.ru/api/vk-edit-manager/", {role, group_id});
        await post("https://ipresent.ru/api/vk-get-groups/").then(setGroups).catch(setGroupsError)
    }

    CONSTANTS["TARIFF_DATA"].trialUntil = CONSTANTS["TARIFF_DATA"].trialUntil.replace("{{trialExpiring}}", new Date(data.trialExpiring).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "long",
        year: "numeric"
    }));
    CONSTANTS["TARIFF_DATA"].paidUntil = CONSTANTS["TARIFF_DATA"].paidUntil.replace("{{paidExpiring}}", new Date(data.paidExpiring).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "long",
        year: "numeric"
    }));
    CONSTANTS["TARIFF_DATA"].paidExpires = CONSTANTS["TARIFF_DATA"].paidExpires.replace("{{paidExpiring}}", new Date(data.paidExpiring).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "long",
        year: "numeric"
    }));
    CONSTANTS["TARIFF_DATA"].recalculatedText = CONSTANTS["TARIFF_DATA"].recalculatedText.replace("{{paidExpiring}}", new Date(data.paidExpiring).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "long",
        year: "numeric"
    }));

    return (
        <DashboardContext.Provider
            value={{
                ...data,
                ...CONSTANTS,
                groups,
                groupsError,
                avatar: data.vk.avatar,
                user_id: data.vk.user_id
            }}
        >
            <App/>
        </DashboardContext.Provider>
    )
}
